import { render, staticRenderFns } from "./desempenho_por_genero.vue?vue&type=template&id=6d20e765&scoped=true&"
import script from "./desempenho_por_genero.vue?vue&type=script&lang=js&"
export * from "./desempenho_por_genero.vue?vue&type=script&lang=js&"
import style0 from "./desempenho_por_genero.vue?vue&type=style&index=0&id=6d20e765&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d20e765",
  null
  
)

export default component.exports